import axios from 'axios'
import { useAuthStore } from '@/stores/auth';
import { useLoadingStore } from '@/stores/loading';

export const urls = {
    login:{
        login:`/api/user/login`,
        logout:`/api/user/logout`,
        userInfo:`/api/user/userInfo`,
        refresh:`/api/user/refresh`,
        checkEmail:`/api/user/checkEmail`,
        // checkID:`/api/user/checkID`,
        register:`/api/user/register`,
        findID:`/api/user/findID`,
        findPassword:`/api/user/findPassword`,
        resetPassword:`/api/user/resetPassword`,
        changePassword:`/api/user/changePassword`,
        list: '/api/user/getList',
        checkActiveLogin:`/api/user/checkActiveLogin`,
        deleteAccount:`/api/user/deleteAccount`,
    },
    patientAdd:{
        patientList:'/api/patientAdd/patientlist',
        patientModify:'/api/patientAdd/patientModify',
        patientDelete:'/api/patientAdd/patientDelete',
        patientRegister:'/api/patientAdd/patientRegister',
        uploadExcel:'/api/patientAdd/uploadPatientExcel',
        getList:'/api/patientAdd/getList',
        // save:'/api/patientAdd/save',
        saveAll:'/api/patientAdd/saveAll',
    },
    patientList:{
        patientData: '/api/patientList/patientData',
        diagnosisSearch: '/api/patientList/diagnosisSearch',
        diagnosisSave: '/api/patientList/diagnosisSave',
        prescriptionSearch: '/api/patientList/prescriptionSearch',
        treatmentData: '/api/patientList/treatmentData',
        prescription: '/api/patientList/prescription',
        count: '/api/patientList/count',
        recordEvent: '/api/patientList/recordEvent',
    },
    protocol:{
        protocolsearch: '/api/protocol/protocolsearch',
        search: '/api/protocol/search',
        save:  '/api/protocol/save',
        checkName:'/api/protocol/checkName',
        savePairs:'/api/protocol/savePairs',
    },
    //환자 목록 처음부분만 적용됨
    diagnosis: {
        result: '/api/patientList/resultList',
    },
}

const api = axios.create({
    withCredentials: true
})

// 인터셉터 설정
api.interceptors.request.use(
    (config) => {
        useLoadingStore().show()
        return config
    },
    (error) => {
        useLoadingStore().hide()
        return Promise.reject(error)
    }
)

api.interceptors.response.use(
    (response) => {
        useLoadingStore().hide()
        if (response.headers['x-token-expired'] === 'true' || response.headers['x-token-refreshed'] === 'true') {
            const newToken = response.headers['authorization']?.replace('Bearer ', '');
            if (newToken) {
                useAuthStore().setToken(newToken)
            }
        }
        return response
    },
    (error) => {
        useLoadingStore().hide()
        if (error.response) {
            const url = error.config?.url

            if (error.response.status === 401) {
                // 1) userInfo에서 온 401이면 안내문 없이 처리
                if (url === urls.login.userInfo) {
                    // 여기서는 조용히만 처리하거나, 필요하면 최소한의 처리만
                    useAuthStore().logout()
                    return Promise.reject(error)
                }

                // 다른기기에서 로그인한 경우.
                alert('세션이 만료되어 로그아웃되었습니다.')
                useAuthStore().logout()

            } else if (error.response.status === 403) {
                useAuthStore().logout();
            }
        }
        return Promise.reject(error)
    }
)

export default api